let credits = false;

export function calcHeader() {
  document.documentElement.style.setProperty('--header-height', $('header.banner').innerHeight()+'px');
}

export function pop_credits() {

  if(credits) {
    $('.site-credits-reveal').remove();
    credits = false;
    return false;
  }

  let html = 'Site built by <a href="//gse-it.stanford.edu" target="_blank">Stanford GSE IT</a> using Wordpress with Laravel Blade. Typography is set in Larsseit and Neue Montreal.';
  $('.site-credits-row').append('<div class="col-12 col-md-7 ml-auto pt-md-1 site-credits-reveal">' + html + '</div>');
  window.scrollBy(0,100);
  credits = true;
}



// WEBPACK FOOTER //
// ./scripts/functions/misc.js